import React, { useState, useEffect } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../Auth/Auth";

import { ButtonWrapper, Button } from "./TabComponent.style";
import Details from "../../Details/Details";

import { SchoolDetails } from "../../RenderDetailsData/RenderDetailsData";
import { SchoolDetailsContainer } from "./TabComponent.style";
import { Input } from "../../Input/InputComponent";
import { LabelComponent } from "../../Details/details.style";
import axios from "axios";
import { schools } from "../../../Api/api";
import { Switch } from "@material-ui/core";

function SchoolDetailsComponent(props) {
  // const {data}=props;
  // let SchoolData=SchoolDetails(props.schoolsData);
  const [loading, setLoading] = useState(false);
  const { setSchoolsData } = props;
  const [SchoolData, setSchoolData] = useState([]);
  const { schoolId } = useParams();
  const { readCookie, DisplaySnackbar } = useAuth();
  const [edit, setEdit] = useState(false);
  const [expiryDate, setExpiryDate] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    brach: "",
    city: "",
    country: "",
    state: "",
    studentCounts: "",
    teacherCounts: "",
  });
  // console.log(SchoolData);
  // console.log(props);
  useEffect(() => {
    if (props.schoolsData.createdAt) {
      setSchoolData(SchoolDetails(props.schoolsData));
      setExpiryDate(
        new Date(props.schoolsData.expiryDate).toISOString().slice(0, 10)
      );
      setFormData({
        name: props.schoolsData.name,
        city: props.schoolsData.city,
        country: props.schoolsData.country,
        state: props.schoolsData.state,
        branch: props.schoolsData.branch,
        teacherCounts: props.schoolsData.teacherCounts,
        studentCounts: props.schoolsData.studentCounts,
      });
    }
  }, [props]);

  const extendExpiryDate = () => {
    console.log(expiryDate);

    axios
      .patch(
        schools.extendExpiryDate(schoolId),
        { expiryDate },
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "success") {
          setSchoolsData({ ...props.schoolsData, expiryDate: expiryDate });
          DisplaySnackbar("ExpiryDate Extended", "success");
        }
      })
      .catch((err) => {
        if (err.response) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };
  const handleUpdate = () => {
    const { name, city, country, state, branch, teacherCounts, studentCounts } =
      formData;
    if (
      !name ||
      !city ||
      !country ||
      !branch ||
      !teacherCounts ||
      !studentCounts ||
      !state
    ) {
      DisplaySnackbar("All fields are mandatory", "error");
      return;
    }

    axios
      .patch(
        schools.upDateSchools(schoolId),
        { ...formData },
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "success") {
          DisplaySnackbar("Update Successfull", "success");
          setSchoolsData({
            ...props.schoolsData,
            name: formData.name,
            city: formData.city,
            country: formData.country,
            branch: formData.branch,
            teacherCounts: formData.teacherCounts,
            studentCounts: formData.studentCounts,
          });

          setEdit(false);
        }
      })
      .catch((err) => console.log(err));
  };

  async function manageAutoRemovalLP() {
    if (loading) return;
    setLoading(true);
    try {
      const res = await axios.get(
        schools.manageAutoRemovalLessonPlan(schoolId),
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      );
      setSchoolsData({
        ...props.schoolsData,
        autoRemoveLessonPlan: res.data.data?.enabled,
      });
      const message = res.data.data?.enabled
        ? `Auto removal enabled, 7 days old lesson plans will be deleted withing 7days`
        : `Auto removal disabled`;
      DisplaySnackbar(message, "success");
    } catch (err) {
      DisplaySnackbar("Failed to update status", "error");
    }
    setLoading(false);
  }

  const handleOnChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  // console.log(SchoolData);
  return (
    <>
      <p
        style={{
          backgroundColor: "#5CE0D2",
          padding: "3px 13px",
          width: "fit-content",
          borderRadius: "10px",
          color: "white",
        }}
      >
        {props.schoolsData.board}
      </p>
      <SchoolDetailsContainer>
        <Details
          width="100%"
          formData={formData}
          handleOnChange={handleOnChange}
          justifycontent="flex-start"
          data={SchoolData}
          edit={edit}
          setEdit={setEdit}
        />
      </SchoolDetailsContainer>

      {edit && (
        <ButtonWrapper style={{ marginRight: "130px" }}>
          <Button onClick={() => setEdit(false)}>Cancel</Button>
          <Button
            onClick={() => {
              handleUpdate();
            }}
          >
            Save
          </Button>
        </ButtonWrapper>
      )}
      <div style={{ display: "flex", marginTop: "40px" }}>
        <div>
          <LabelComponent>Extend Expiry Date</LabelComponent>
          <Input
            height="36px"
            handleOnChange={(e) => setExpiryDate(e.target.value)}
            border="none"
            edit={true}
            type="date"
            value={expiryDate}
            placeholder="dd-mm-yyyy"
          />
        </div>
        <ButtonWrapper
          style={{ marginTop: "15px", display: "flex", alignItems: "center" }}
        >
          <Button
            onClick={() => extendExpiryDate()}
            style={{ display: "block" }}
          >
            Save
          </Button>
        </ButtonWrapper>
        <br />
      </div>
      <div style={{ marginTop: "60px" }}>
        <h5 style={{ fontWeight: "Bold", fontSize: "1rem" }}>
          Auto Remove 7 days old Lesson Plans
        </h5>
        <button
          disabled={loading}
          onClick={manageAutoRemovalLP}
          style={{
            border: `2px solid ${
              props.schoolsData.autoRemoveLessonPlan ? "orangered" : "gray"
            }`,
            background: "transparent",
            color: props.schoolsData.autoRemoveLessonPlan
              ? "orangered"
              : "gray",
            fontSize: "1rem",
            borderRadius: "8px",
            marginTop: "15px",
            padding: "5px 20px",
            fontWeight: "bold",
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? "opacity-50" : "",
          }}
        >
          {props.schoolsData.autoRemoveLessonPlan ? "Enabled" : "Disabled"}
        </button>
      </div>
    </>
  );
}

export default SchoolDetailsComponent;
